/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import TextField from "components/text-field/text-field";
import { get } from "lodash";

import {
  FacebookConfig,
  TwitterConfig,
  LinkedinConfig,
  GettyConfig,
  MetypeConfig,
  Integrations
} from "api/integrations";
import { isClientValidationError } from "utils/validation.utils";

type GeneralIntegration =
  | { key: Integrations.Facebook; value: FacebookConfig }
  | { key: Integrations.Twitter; value: TwitterConfig }
  | { key: Integrations.Linkedin; value: LinkedinConfig }
  | { key: Integrations.Getty; value: GettyConfig }
  | { key: Integrations.Metype; value: MetypeConfig };

interface Props {
  integration: GeneralIntegration;
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
}

const GeneralIntegration: React.SFC<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;
  return (
    <React.Fragment>
      <TextField
        label={t("integrations.fields.api-key")}
        value={integration.value["api-key"]}
        onChange={(value) => updateIntegrationField(integrationName, { "api-key": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<GeneralIntegration>(errors)
            ? get(errors, ["errors", "value", "api-key", "0"])
            : undefined
        }
      />
      <TextField
        label={t("integrations.fields.api-secret")}
        value={integration.value["api-secret"]}
        onChange={(value) => updateIntegrationField(integrationName, { "api-secret": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<GeneralIntegration>(errors)
            ? get(errors, ["errors", "value", "api-secret", "0"])
            : undefined
        }
      />
    </React.Fragment>
  );
};

export default GeneralIntegration;
